"use client";
import React, { useContext, useState } from "react";
import styles from "./styles.module.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../../Assets/images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { generateYupSchema } from "../../App/Helpers/ValidationSchema/validator.js";
import { UsersApi } from "../../App/api/users.api.js";
import { toast } from "react-toastify";
import LoaderContext from "../loader/LoaderContext.js";
import { IoMdClose } from "react-icons/io";

function ResetPassword({meta,handleResetClose,email}) {
  const [isPassword, setIsPassword] = useState(false);
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);

  const { handleLoading } = useContext(LoaderContext);

  const navigate = useNavigate();
  const location = useLocation();
  const { emailOrPhone } = location.state || {};

  const initialValues = {
    emailOrPhone:email||"",
    new_password: "",
    confirm_password: "",
  };

  const { handleChange, values, handleSubmit, errors, handleBlur, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema: generateYupSchema(initialValues),
      onSubmit: async () => {
        handleLoading(true);
        const payload = {
          emailOrPhone: values.emailOrPhone,
          newPassword: values.new_password,
        };
        // console.log("payload", payload);
        try {
          const res = await UsersApi.resetPassword(payload);
          toast.success("Password reset successfully");
          navigate("/");
          handleLoading(false);
        } catch (err) {
          // console.log(err);
          toast.error("Reset Password failed");
          handleLoading(false);
        }
      },
    });

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
   <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
     <div className="bg-white  p-4 rounded-lg shadow-lg w-full max-w-xl">
      <div className="flex justify-between border-b pb-2 text-gray-900 text-lg font-semibold">
          <span>Reset Password</span>
          <span>
            <IoMdClose onClick={handleResetClose} />
          </span>
        </div>
        <form onSubmit={handleSubmit} className={styles.Loginform}>
          <div className={styles.inputWrapper}>
            <label className={styles.label} htmlFor="emailOrPhone">
             Email
            </label>
            {errors.emailOrPhone && touched.emailOrPhone ? (
              <p
                style={{ paddingLeft: "0", paddingBlock: ".875rem" }}
                className="ess-form-error"
              >
                {" "}
                {errors.emailOrPhone}{" "}
              </p>
            ) : null}
            <div style={{ position: "relative" }}>
              <input
                className={styles.input}
                id="emailOrPhone"
                name="emailOrPhone"
                value={values.emailOrPhone}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="emailOrPhone"
                type={"email"}
              />
              
            </div>
          </div>
          <div className={styles.inputWrapper}>
            <label className={styles.label} htmlFor="Password">
              New Password
            </label>
            {errors.new_password && touched.new_password ? (
              <p
                style={{ paddingLeft: "0", paddingBlock: ".875rem" }}
                className="ess-form-error"
              >
                {" "}
                {errors.new_password}{" "}
              </p>
            ) : null}
            <div style={{ position: "relative" }}>
              <input
                className={styles.input}
                id="password"
                name="new_password"
                value={values.new_password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Password"
                type={isPassword ? "text" : "password"}
              />
              {isPassword ? (
                <FaEye
                  onClick={() => setIsPassword(!isPassword)}
                  className={styles.passwordEye}
                />
              ) : (
                <FaEyeSlash
                  onClick={() => setIsPassword(!isPassword)}
                  className={styles.passwordEye}
                />
              )}
            </div>
          </div>
          <div className={styles.inputWrapper}>
            <label className={styles.label} htmlFor="confirmPassword">
              Confirm Password
            </label>
            {errors.confirm_password && touched.confirm_password ? (
              <p
                style={{ paddingLeft: "0", paddingBlock: ".875rem" }}
                className="ess-form-error"
              >
                {" "}
                {errors.confirm_password}{" "}
              </p>
            ) : null}
            <div style={{ position: "relative" }}>
              <input
                className={styles.input}
                id="confirmPassword"
                name="confirm_password"
                value={values.confirm_password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Password"
                type={isConfirmPassword ? "text" : "password"}
              />
              {isConfirmPassword ? (
                <FaEye
                  onClick={() => setIsConfirmPassword(!isConfirmPassword)}
                  className={styles.passwordEye}
                />
              ) : (
                <FaEyeSlash
                  onClick={() => setIsConfirmPassword(!isConfirmPassword)}
                  className={styles.passwordEye}
                />
              )}
            </div>
          </div>
          <div className={`${styles.buttonWrapper} justify-center gap-4`}>
            <p className="border justify-center items-center flex px-4 rounded-full font-semibold text-lg" onClick={handleResetClose}>
              Cancel
            </p>
            <button className={styles.button}>Update password</button>
          </div>
        </form>
      
    </div>
   </div>
  );
}

export default ResetPassword;
